export const HOME = '/';
export const SIGN_IN = '/login';
export const FILM_DETAIL = '/film/:id';
export const DASHBOARD = '/dashboard';
